import BigNumber from 'bignumber.js';

import type { LiquidityHub } from 'types';

import {
  busdCoreYieldGroup,
  busdFluxYieldGroup,
  usdcCoreYieldGroup,
  usdcFluxYieldGroup,
  usdtCoreYieldGroup,
  usdtFluxYieldGroup,
  xvsCoreYieldGroup,
  xvsFluxYieldGroup,
} from './liquidityHubYieldGroups';
import { xvs } from './tokens';
import { vhBusd, vhUsdc, vhUsdt, vhXvs } from './vhTokens';

export const liquidityHubs: LiquidityHub[] = [
  {
    hubAddress: '0x1000000000000000000000000000000000000001',
    vhToken: vhXvs,
    tokenPriceCents: new BigNumber(715),
    tokenPriceOracleAddress: '0x3000000000000000000000000000000000000001',
    supplyBalanceTokens: new BigNumber(15250),
    supplyBalanceCents: new BigNumber(10903750),
    liquidityTokens: new BigNumber(12000),
    liquidityCents: new BigNumber(8580000),
    supplyCapTokens: new BigNumber(25000),
    supplyApyPercentage: new BigNumber(6.2),
    performanceFeePercentage: new BigNumber(10),
    redeemFeePercentage: new BigNumber(1),
    pricePerShare: new BigNumber(1.06),
    supplierCount: 124,
    operatorName: 'Venus Core',
    yieldGroups: [xvsCoreYieldGroup, xvsFluxYieldGroup],
    supplyTokenDistributions: [
      {
        type: 'venus',
        token: xvs,
        apyPercentage: new BigNumber(1.2),
        dailyDistributedTokens: new BigNumber(150),
        isActive: true,
      },
    ],
    userWalletBalanceTokens: new BigNumber(95),
    userWalletBalanceCents: new BigNumber(67925),
    userSupplyBalanceTokens: new BigNumber(42),
    userSupplyBalanceCents: new BigNumber(30030),
    userYearlyEarningsCents: new BigNumber('1861.86'),
    userVhTokenBalanceTokens: new BigNumber('39.62264150943396226415'),
  },
  {
    hubAddress: '0x1000000000000000000000000000000000000002',
    vhToken: vhUsdc,
    tokenPriceCents: new BigNumber(100),
    tokenPriceOracleAddress: '0x3000000000000000000000000000000000000002',
    supplyBalanceTokens: new BigNumber(350000),
    supplyBalanceCents: new BigNumber(35000000),
    liquidityTokens: new BigNumber(290000),
    liquidityCents: new BigNumber(29000000),
    supplyCapTokens: new BigNumber(500000),
    supplyApyPercentage: new BigNumber(4.1),
    performanceFeePercentage: new BigNumber(8),
    redeemFeePercentage: new BigNumber(0),
    pricePerShare: new BigNumber(1.02),
    supplierCount: 289,
    operatorName: 'Stable Strategies',
    yieldGroups: [usdcCoreYieldGroup, usdcFluxYieldGroup],
    supplyTokenDistributions: [
      {
        type: 'venus',
        token: xvs,
        apyPercentage: new BigNumber(0.75),
        dailyDistributedTokens: new BigNumber(75),
        isActive: true,
      },
    ],
    userWalletBalanceTokens: new BigNumber(2500),
    userWalletBalanceCents: new BigNumber(250000),
    userSupplyBalanceTokens: new BigNumber(1200),
    userSupplyBalanceCents: new BigNumber(120000),
    userYearlyEarningsCents: new BigNumber(4920),
    userVhTokenBalanceTokens: new BigNumber('1176.47058823529411764706'),
  },
  {
    hubAddress: '0x1000000000000000000000000000000000000003',
    vhToken: vhUsdt,
    tokenPriceCents: new BigNumber(100),
    tokenPriceOracleAddress: '0x3000000000000000000000000000000000000003',
    supplyBalanceTokens: new BigNumber(210000),
    supplyBalanceCents: new BigNumber(21000000),
    liquidityTokens: new BigNumber(166000),
    liquidityCents: new BigNumber(16600000),
    supplyCapTokens: new BigNumber(320000),
    supplyApyPercentage: new BigNumber(4.85),
    performanceFeePercentage: new BigNumber(9),
    redeemFeePercentage: new BigNumber(1.2),
    pricePerShare: new BigNumber(1.03),
    supplierCount: 198,
    operatorName: 'Yield Relay',
    yieldGroups: [usdtCoreYieldGroup, usdtFluxYieldGroup],
    supplyTokenDistributions: [],
    userWalletBalanceTokens: new BigNumber(1800),
    userWalletBalanceCents: new BigNumber(180000),
    userSupplyBalanceTokens: new BigNumber(850),
    userSupplyBalanceCents: new BigNumber(85000),
    userYearlyEarningsCents: new BigNumber('4122.5'),
    userVhTokenBalanceTokens: new BigNumber('825.24271844660194174757'),
  },
  {
    hubAddress: '0x1000000000000000000000000000000000000004',
    vhToken: vhBusd,
    tokenPriceCents: new BigNumber(100),
    tokenPriceOracleAddress: '0x3000000000000000000000000000000000000004',
    supplyBalanceTokens: new BigNumber(180000),
    supplyBalanceCents: new BigNumber(18000000),
    liquidityTokens: new BigNumber(141000),
    liquidityCents: new BigNumber(14100000),
    supplyCapTokens: new BigNumber(260000),
    supplyApyPercentage: new BigNumber(3.95),
    performanceFeePercentage: new BigNumber(7.5),
    redeemFeePercentage: new BigNumber(0),
    pricePerShare: new BigNumber(1.01),
    supplierCount: 164,
    operatorName: 'Reserve Engine',
    yieldGroups: [busdCoreYieldGroup, busdFluxYieldGroup],
    supplyTokenDistributions: [],
    userWalletBalanceTokens: new BigNumber(3200),
    userWalletBalanceCents: new BigNumber(320000),
    userSupplyBalanceTokens: new BigNumber(1400),
    userSupplyBalanceCents: new BigNumber(140000),
    userYearlyEarningsCents: new BigNumber(5530),
    userVhTokenBalanceTokens: new BigNumber('1386.13861386138613861386'),
  },
];
